export default "__VITE_ASSET__M7XsMgq4__"